import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addUpdateSingleCMS, addUpdateSingleFAQ, cmsList, contactUsList, deleteSingleCMS, faqList } from "../apis/apiHandler";

export const cms = createAsyncThunk(
    "cms/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await cmsList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const faq = createAsyncThunk(
    "faq/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await faqList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);




const initialState = {
    loading: false,
    cmsList: [],
    faqList: [],
    error: null,
    success: false,
};

const cmsSlice = createSlice({
    name: "blog",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(cms.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(cms.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.cmsList = payload;
                state.success = true;
            })
            .addCase(cms.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })      
            .addCase(faq.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(faq.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.faqList = payload;
                state.success = true;
            })
            .addCase(faq.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
           
    },
});

export default cmsSlice.reducer;
